
import {buffer, getWidth, getHeight} from '../node_modules/ol/extent.js';

import {map} from './index.js';
import {changePage} from './changePage.js';

export default function() {
  let layersource =  map.getLayerByTitle('lyrVector').getSource();
  if (layersource.getFeatures().length) {
    changePage('mappage');
    let extent = layersource.getExtent();
    extent = buffer(extent, (getWidth(extent) + getHeight(extent)) / 6);
    map.updateSize();   // fixes map sometimes not displaying
    map.getView().fit(extent, map.getSize());
  } else {
    console.warn('in zoomToVectorExtents() with no vector features')
  }
}

/*
zoomToFeature = function(id) {  // incomplete

  var extent = map.getLayerByTitle('lyrVector').getSource().getFeatureById(id).getGeometry().getExtent();
  // return '<a href="javascript:rwg.detailTab(\'' +  dat + '\')" class="mapPIDN">Property&nbsp;Detail</a>';

};
*/
